import { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { searchMovies } from "@/utils/movieUtils";
import MovieCard from "@/components/feature/MovieCard";
import Breadcrumb from "@/components/feature/Breadcrumb";
import EmptyState from "@/components/feature/EmptyState";
import SearchBox from "@/components/feature/SearchBox";

const hotKeywords = ["悬疑", "爱情", "治愈", "东京", "科幻", "美食"];

export default function Search() {
  const [params] = useSearchParams();
  const query = (params.get("q") || "").trim();
  const results = useMemo(() => searchMovies(query), [query]);

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-6 md:px-8 md:py-8">
      <Breadcrumb
        items={[{ label: "首页", to: "/" }, { label: "搜索结果" }]}
      />

      <div className="mt-4 rounded-lg bg-secondary-900 px-6 py-8 md:px-10 md:py-10">
        <h1 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
          搜索影视
        </h1>
        <div className="mt-5 max-w-2xl">
          <SearchBox defaultValue={query} variant="hero" />
        </div>
        {query && (
          <p className="mt-4 text-sm text-background-200">
            关键词：
            <strong className="font-semibold text-accent-400">「{query}」</strong>
            ，共找到
            <strong className="mx-1 font-semibold text-accent-400">
              {results.length}
            </strong>
            部作品
          </p>
        )}
      </div>

      {!query ? (
        <div className="mt-6">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-900">
              请输入关键词开始搜索
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              支持按影视标题、剧情简介、类型、地区等关键词匹配作品。
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <span className="text-sm text-foreground-400">热门搜索：</span>
              {hotKeywords.map((kw) => (
                <Link
                  key={kw}
                  to={`/search?q=${encodeURIComponent(kw)}`}
                  className="rounded-md bg-background-100 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-600"
                >
                  {kw}
                </Link>
              ))}
            </div>
          </div>
        </div>
      ) : results.length > 0 ? (
        <div className="mt-6 grid grid-cols-2 gap-3 md:gap-5 sm:grid-cols-3 lg:grid-cols-4">
          {results.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      ) : (
        <div className="mt-6">
          <EmptyState
            icon="ri-search-eye-line"
            title="没有找到相关影视作品"
            description="没有匹配的内容，试试更换关键词，例如作品名、类型或地区。"
          />
          <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
            <span className="text-sm text-foreground-400">换个关键词试试：</span>
            {hotKeywords.map((kw) => (
              <Link
                key={kw}
                to={`/search?q=${encodeURIComponent(kw)}`}
                className="rounded-md bg-background-100 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-600"
              >
                {kw}
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}